// Web CRM (Business plane) — Scheduling plane i18n (STATIC UI CHROME ONLY).
// Same flat-key + English-fallback semantics as the other i18n modules; merged into the shared
// per-language lookup in translations.js. NEVER used for dynamic/backend content (customer ids,
// provider names, thread messages, policy reference ids) — those render verbatim from the API.
//
// Backing endpoints (all real, in the scheduling backend candidate):
//   GET  /api/v1/scheduling/appointments            (list + per-row allowed_actions)
//   GET  /api/v1/scheduling/appointments/{id}       (detail + policy + allowed_actions + thread)
//   POST /api/v1/scheduling/appointments/{id}/confirm|decline|cancel|reschedule
//   GET  /api/v1/scheduling/availability            (real slots for reschedule — never invented)

const schedulingTranslations = {
  en: {
    'nav.scheduling': 'Scheduling',
    'navdesc.manageScheduling': 'Appointments & bookings',
    'page.scheduling.title': 'Scheduling',
    'page.scheduling.subtitle': 'Manage appointments and bookings for {business}',

    'sched.loading': 'Loading appointments…',
    'sched.failedLoad': 'Failed to load appointments',
    'sched.empty': 'No appointments match the current filters.',
    'sched.emptyHint': 'Appointments booked via AI chat or voice appear here.',
    'sched.results': '{count} shown',
    'sched.showingRange': 'Showing {from}–{to} of {total}',
    'sched.page.prev': 'Previous',
    'sched.page.next': 'Next',

    'sched.waitlist.title': 'Waitlist',
    'sched.waitlist.empty': 'No one is waiting.',
    'sched.waitlist.remove': 'Remove',
    'sched.waitlist.window': 'Preferred',
    'sched.waitlist.customer': 'Customer',
    'sched.waitlist.updated': 'Waitlist updated',
    'sched.waitlist.updateFailed': 'Could not update the waitlist',
    'sched.filters': 'Filters',
    'sched.filter.status': 'Status',
    'sched.filter.allStatuses': 'All statuses',
    'sched.filter.provider': 'Provider ID',
    'sched.filter.customer': 'Customer ID',
    'sched.filter.from': 'From',
    'sched.filter.to': 'To',
    'sched.filter.clear': 'Clear',

    'sched.col.when': 'When',
    'sched.col.type': 'Type',
    'sched.col.provider': 'Provider',
    'sched.col.customer': 'Customer',
    'sched.col.status': 'Status',

    'sched.status.pending': 'Pending',
    'sched.status.confirmed': 'Confirmed',
    'sched.status.declined': 'Declined',
    'sched.status.cancelled': 'Cancelled',
    'sched.status.completed': 'Completed',
    'sched.status.failed': 'Failed',
    'sched.status.requested': 'Requested',
    'sched.status.reschedule_requested': 'Reschedule requested',
    'sched.status.rescheduled': 'Rescheduled',
    'sched.status.no_show': 'No-show',
    'sched.status.expired': 'Expired',

    'sched.detail.title': 'Appointment',
    'sched.detail.select': 'Select an appointment to view details.',
    'sched.detail.customer': 'Customer',
    'sched.detail.provider': 'Provider',
    'sched.detail.type': 'Appointment type',
    'sched.detail.start': 'Start',
    'sched.detail.end': 'End',
    'sched.detail.mode': 'Scheduling mode',
    'sched.detail.resource': 'Resource',
    'sched.detail.created': 'Created',
    'sched.detail.updated': 'Updated',
    'sched.detail.confirmationSource': 'Confirmation source',
    'sched.detail.requirements': 'Requirements',

    'sched.req.approval': 'Approval required',
    'sched.req.payment': 'Payment required',
    'sched.req.document': 'Document required',

    'sched.policy.title': 'Policies',
    'sched.captureConsent.title': 'Recording consent',
    'sched.captureConsent.type.audio': 'Audio recording',
    'sched.captureConsent.type.video': 'Video recording',
    'sched.captureConsent.type.screen': 'Screen recording',
    'sched.captureConsent.type.text': 'Written record',
    'sched.captureConsent.state.required': 'Required',
    'sched.captureConsent.state.granted': 'Granted',
    'sched.captureConsent.state.withdrawn': 'Withdrawn',
    'sched.captureConsent.state.expired': 'Expired',
    'sched.captureConsent.state.not_required': 'Not required',
    'sched.policy.cancellation': 'Cancellation',
    'sched.policy.reschedule': 'Reschedule',
    'sched.policy.confirmation': 'Confirmation',
    'sched.policy.allowCustomerCancel': 'Customer self-cancel',
    'sched.policy.allowCustomerReschedule': 'Customer self-reschedule',
    'sched.policy.minNotice': 'Min. notice (min)',
    'sched.policy.maxReschedules': 'Max reschedules',
    'sched.policy.meetsNotice': 'Meets notice window',
    'sched.policy.mode': 'Mode',
    'sched.policy.expiresAfter': 'Expires after (min)',
    'sched.policy.knowledgeRefs': 'Policy references',
    'sched.policy.knowledgeRefsHint': 'Reference IDs only — no content shown.',
    'sched.policy.unlimited': 'Unlimited',

    'sched.thread.title': 'Activity',
    'sched.thread.none': 'No linked conversation.',
    'sched.thread.empty': 'No activity yet.',
    'sched.thread.loading': 'Loading activity…',

    'sched.engine.title': 'Engine metadata',
    'sched.engine.none': 'None',

    'sched.doc.title': 'Document',
    'sched.draftsTitle': 'Clinical documentation',
    'sched.doc.view': 'View',
    'sched.doc.accept': 'Accept',
    'sched.doc.reject': 'Reject',
    'sched.doc.reasonOptional': 'Reason (optional)',
    'sched.doc.confirmReject': 'Confirm rejection',
    'sched.doc.cancelReject': 'Cancel',
    'sched.doc.loading': 'Loading document…',
    'sched.doc.retry': 'Retry',
    'sched.doc.viewFailed': 'Could not open the file.',
    'sched.doc.decisionFailed': 'The decision could not be saved.',
    'sched.doc.confirmBlocked': 'This booking cannot be confirmed until the required document is accepted.',
    'sched.action.confirm': 'Confirm',
    'sched.action.decline': 'Decline',
    'sched.action.cancel': 'Cancel booking',
    'sched.action.reschedule': 'Reschedule',
    'sched.action.noneAvailable': 'No actions available for your role or this status.',

    'sched.cancel.title': 'Cancel booking',
    'sched.cancel.reason': 'Reason (optional)',
    'sched.cancel.override': 'Override notice policy (management)',
    'sched.cancel.submit': 'Confirm cancellation',
    'sched.decline.title': 'Decline appointment',
    'sched.decline.reason': 'Reason (optional)',
    'sched.decline.submit': 'Confirm decline',
    'sched.confirm.title': 'Confirm appointment',
    'sched.confirm.body': 'Approve this appointment? The customer will see it as confirmed.',
    'sched.resched.title': 'Reschedule appointment',
    'sched.resched.pick': 'Choose a new time',
    'sched.resched.loading': 'Loading available times…',
    'sched.resched.none': 'No available times for this type and provider.',
    'sched.resched.reason': 'Reason (optional)',
    'sched.resched.submit': 'Confirm reschedule',
    'sched.resched.override': 'Override notice policy (management)',

    'sched.toast.confirmed': 'Appointment confirmed',
    'sched.toast.declined': 'Appointment declined',
    'sched.toast.cancelled': 'Appointment cancelled',
    'sched.toast.rescheduled': 'Appointment rescheduled',
    'sched.toast.failed': 'Action failed',
  },

  es: {
    'nav.scheduling': 'Agenda',
    'navdesc.manageScheduling': 'Citas y reservas',
    'page.scheduling.title': 'Agenda',
    'page.scheduling.subtitle': 'Gestiona citas y reservas de {business}',
    'sched.loading': 'Cargando citas…',
    'sched.failedLoad': 'Error al cargar las citas',
    'sched.empty': 'Ninguna cita coincide con los filtros actuales.',
    'sched.emptyHint': 'Las citas reservadas por chat o voz con IA aparecen aquí.',
    'sched.results': '{count} mostradas',
    'sched.showingRange': 'Mostrando {from}–{to} de {total}',
    'sched.page.prev': 'Anterior',
    'sched.page.next': 'Siguiente',
    'sched.waitlist.title': 'Lista de espera',
    'sched.waitlist.empty': 'No hay nadie esperando.',
    'sched.waitlist.remove': 'Quitar',
    'sched.waitlist.window': 'Preferido',
    'sched.waitlist.customer': 'Cliente',
    'sched.waitlist.updated': 'Lista de espera actualizada',
    'sched.waitlist.updateFailed': 'No se pudo actualizar la lista de espera',
    'sched.filters': 'Filtros',
    'sched.filter.status': 'Estado',
    'sched.filter.allStatuses': 'Todos los estados',
    'sched.filter.provider': 'ID de proveedor',
    'sched.filter.customer': 'ID de cliente',
    'sched.filter.from': 'Desde',
    'sched.filter.to': 'Hasta',
    'sched.filter.clear': 'Limpiar',
    'sched.col.when': 'Cuándo',
    'sched.col.type': 'Tipo',
    'sched.col.provider': 'Proveedor',
    'sched.col.customer': 'Cliente',
    'sched.col.status': 'Estado',
    'sched.status.pending': 'Pendiente',
    'sched.status.confirmed': 'Confirmada',
    'sched.status.declined': 'Rechazada',
    'sched.status.cancelled': 'Cancelada',
    'sched.status.completed': 'Completada',
    'sched.status.failed': 'Fallida',
    'sched.status.requested': 'Solicitada',
    'sched.status.reschedule_requested': 'Cambio solicitado',
    'sched.status.rescheduled': 'Reprogramada',
    'sched.status.no_show': 'No asistió',
    'sched.status.expired': 'Vencida',
    'sched.detail.title': 'Cita',
    'sched.detail.select': 'Selecciona una cita para ver los detalles.',
    'sched.detail.customer': 'Cliente',
    'sched.detail.provider': 'Proveedor',
    'sched.detail.type': 'Tipo de cita',
    'sched.detail.start': 'Inicio',
    'sched.detail.end': 'Fin',
    'sched.detail.mode': 'Modo de agenda',
    'sched.detail.resource': 'Recurso',
    'sched.detail.created': 'Creada',
    'sched.detail.updated': 'Actualizada',
    'sched.detail.confirmationSource': 'Origen de confirmación',
    'sched.detail.requirements': 'Requisitos',
    'sched.req.approval': 'Requiere aprobación',
    'sched.req.payment': 'Requiere pago',
    'sched.req.document': 'Requiere documento',
    'sched.policy.title': 'Políticas',
    'sched.captureConsent.title': 'Consentimiento de grabación',
    'sched.captureConsent.type.audio': 'Grabación de audio',
    'sched.captureConsent.type.video': 'Grabación de vídeo',
    'sched.captureConsent.type.screen': 'Grabación de pantalla',
    'sched.captureConsent.type.text': 'Registro escrito',
    'sched.captureConsent.state.required': 'Requerido',
    'sched.captureConsent.state.granted': 'Concedido',
    'sched.captureConsent.state.withdrawn': 'Retirado',
    'sched.captureConsent.state.expired': 'Caducado',
    'sched.captureConsent.state.not_required': 'No requerido',
    'sched.policy.cancellation': 'Cancelación',
    'sched.policy.reschedule': 'Reprogramación',
    'sched.policy.confirmation': 'Confirmación',
    'sched.policy.allowCustomerCancel': 'Autocancelación del cliente',
    'sched.policy.allowCustomerReschedule': 'Autoreprogramación del cliente',
    'sched.policy.minNotice': 'Aviso mín. (min)',
    'sched.policy.maxReschedules': 'Máx. reprogramaciones',
    'sched.policy.meetsNotice': 'Cumple el aviso',
    'sched.policy.mode': 'Modo',
    'sched.policy.expiresAfter': 'Expira tras (min)',
    'sched.policy.knowledgeRefs': 'Referencias de política',
    'sched.policy.knowledgeRefsHint': 'Solo IDs de referencia — sin contenido.',
    'sched.policy.unlimited': 'Ilimitado',
    'sched.thread.title': 'Actividad',
    'sched.thread.none': 'Sin conversación vinculada.',
    'sched.thread.empty': 'Sin actividad todavía.',
    'sched.thread.loading': 'Cargando actividad…',
    'sched.engine.title': 'Metadatos del motor',
    'sched.engine.none': 'Ninguno',
    'sched.doc.title': 'Documento',
    'sched.draftsTitle': 'Documentación clínica',
    'sched.doc.view': 'Ver',
    'sched.doc.accept': 'Aceptar',
    'sched.doc.reject': 'Rechazar',
    'sched.doc.reasonOptional': 'Motivo (opcional)',
    'sched.doc.confirmReject': 'Confirmar rechazo',
    'sched.doc.cancelReject': 'Cancelar',
    'sched.doc.loading': 'Cargando documento…',
    'sched.doc.retry': 'Reintentar',
    'sched.doc.viewFailed': 'No se pudo abrir el archivo.',
    'sched.doc.decisionFailed': 'No se pudo guardar la decisión.',
    'sched.doc.confirmBlocked': 'Esta cita no puede confirmarse hasta que se acepte el documento requerido.',
    'sched.action.confirm': 'Confirmar',
    'sched.action.decline': 'Rechazar',
    'sched.action.cancel': 'Cancelar reserva',
    'sched.action.reschedule': 'Reprogramar',
    'sched.action.noneAvailable': 'No hay acciones disponibles para tu rol o este estado.',
    'sched.cancel.title': 'Cancelar reserva',
    'sched.cancel.reason': 'Motivo (opcional)',
    'sched.cancel.override': 'Anular política de aviso (gestión)',
    'sched.cancel.submit': 'Confirmar cancelación',
    'sched.decline.title': 'Rechazar cita',
    'sched.decline.reason': 'Motivo (opcional)',
    'sched.decline.submit': 'Confirmar rechazo',
    'sched.confirm.title': 'Confirmar cita',
    'sched.confirm.body': '¿Aprobar esta cita? El cliente la verá como confirmada.',
    'sched.resched.title': 'Reprogramar cita',
    'sched.resched.pick': 'Elige un nuevo horario',
    'sched.resched.loading': 'Cargando horarios disponibles…',
    'sched.resched.none': 'No hay horarios disponibles para este tipo y proveedor.',
    'sched.resched.reason': 'Motivo (opcional)',
    'sched.resched.submit': 'Confirmar reprogramación',
    'sched.resched.override': 'Anular política de aviso (gestión)',
    'sched.toast.confirmed': 'Cita confirmada',
    'sched.toast.declined': 'Cita rechazada',
    'sched.toast.cancelled': 'Cita cancelada',
    'sched.toast.rescheduled': 'Cita reprogramada',
    'sched.toast.failed': 'La acción falló',
  },

  fr: {
    'nav.scheduling': 'Planning',
    'navdesc.manageScheduling': 'Rendez-vous et réservations',
    'page.scheduling.title': 'Planning',
    'page.scheduling.subtitle': 'Gérer les rendez-vous et réservations de {business}',
    'sched.loading': 'Chargement des rendez-vous…',
    'sched.failedLoad': 'Échec du chargement des rendez-vous',
    'sched.empty': 'Aucun rendez-vous ne correspond aux filtres actuels.',
    'sched.emptyHint': 'Les rendez-vous pris via le chat ou la voix IA apparaissent ici.',
    'sched.results': '{count} affichés',
    'sched.showingRange': 'Affichage de {from}–{to} sur {total}',
    'sched.page.prev': 'Précédent',
    'sched.page.next': 'Suivant',
    'sched.waitlist.title': 'Liste d’attente',
    'sched.waitlist.empty': 'Personne n’attend.',
    'sched.waitlist.remove': 'Retirer',
    'sched.waitlist.window': 'Souhaité',
    'sched.waitlist.customer': 'Client',
    'sched.waitlist.updated': 'Liste d’attente mise à jour',
    'sched.waitlist.updateFailed': 'Impossible de mettre à jour la liste d’attente',
    'sched.filters': 'Filtres',
    'sched.filter.status': 'Statut',
    'sched.filter.allStatuses': 'Tous les statuts',
    'sched.filter.provider': 'ID prestataire',
    'sched.filter.customer': 'ID client',
    'sched.filter.from': 'Du',
    'sched.filter.to': 'Au',
    'sched.filter.clear': 'Effacer',
    'sched.col.when': 'Quand',
    'sched.col.type': 'Type',
    'sched.col.provider': 'Prestataire',
    'sched.col.customer': 'Client',
    'sched.col.status': 'Statut',
    'sched.status.pending': 'En attente',
    'sched.status.confirmed': 'Confirmé',
    'sched.status.declined': 'Refusé',
    'sched.status.cancelled': 'Annulé',
    'sched.status.completed': 'Terminé',
    'sched.status.failed': 'Échoué',
    'sched.status.requested': 'Demandé',
    'sched.status.reschedule_requested': 'Report demandé',
    'sched.status.rescheduled': 'Reprogrammé',
    'sched.status.no_show': 'Absence',
    'sched.status.expired': 'Expiré',
    'sched.detail.title': 'Rendez-vous',
    'sched.detail.select': 'Sélectionnez un rendez-vous pour voir les détails.',
    'sched.detail.customer': 'Client',
    'sched.detail.provider': 'Prestataire',
    'sched.detail.type': 'Type de rendez-vous',
    'sched.detail.start': 'Début',
    'sched.detail.end': 'Fin',
    'sched.detail.mode': 'Mode de planification',
    'sched.detail.resource': 'Ressource',
    'sched.detail.created': 'Créé',
    'sched.detail.updated': 'Mis à jour',
    'sched.detail.confirmationSource': 'Source de confirmation',
    'sched.detail.requirements': 'Exigences',
    'sched.req.approval': 'Approbation requise',
    'sched.req.payment': 'Paiement requis',
    'sched.req.document': 'Document requis',
    'sched.policy.title': 'Politiques',
    'sched.captureConsent.title': 'Consentement a l\'enregistrement',
    'sched.captureConsent.type.audio': 'Enregistrement audio',
    'sched.captureConsent.type.video': 'Enregistrement video',
    'sched.captureConsent.type.screen': 'Enregistrement de l\'ecran',
    'sched.captureConsent.type.text': 'Compte rendu ecrit',
    'sched.captureConsent.state.required': 'Requis',
    'sched.captureConsent.state.granted': 'Accorde',
    'sched.captureConsent.state.withdrawn': 'Retire',
    'sched.captureConsent.state.expired': 'Expire',
    'sched.captureConsent.state.not_required': 'Non requis',
    'sched.policy.cancellation': 'Annulation',
    'sched.policy.reschedule': 'Report',
    'sched.policy.confirmation': 'Confirmation',
    'sched.policy.allowCustomerCancel': 'Auto-annulation client',
    'sched.policy.allowCustomerReschedule': 'Auto-report client',
    'sched.policy.minNotice': 'Préavis min. (min)',
    'sched.policy.maxReschedules': 'Reports max.',
    'sched.policy.meetsNotice': 'Respecte le préavis',
    'sched.policy.mode': 'Mode',
    'sched.policy.expiresAfter': 'Expire après (min)',
    'sched.policy.knowledgeRefs': 'Références de politique',
    'sched.policy.knowledgeRefsHint': 'IDs de référence seulement — aucun contenu affiché.',
    'sched.policy.unlimited': 'Illimité',
    'sched.thread.title': 'Activité',
    'sched.thread.none': 'Aucune conversation liée.',
    'sched.thread.empty': 'Aucune activité pour le moment.',
    'sched.thread.loading': 'Chargement de l’activité…',
    'sched.engine.title': 'Métadonnées du moteur',
    'sched.engine.none': 'Aucune',
    'sched.doc.title': 'Document',
    'sched.draftsTitle': 'Documentation clinique',
    'sched.doc.view': 'Voir',
    'sched.doc.accept': 'Accepter',
    'sched.doc.reject': 'Refuser',
    'sched.doc.reasonOptional': 'Motif (facultatif)',
    'sched.doc.confirmReject': 'Confirmer le refus',
    'sched.doc.cancelReject': 'Annuler',
    'sched.doc.loading': 'Chargement du document…',
    'sched.doc.retry': 'Réessayer',
    'sched.doc.viewFailed': 'Impossible d\'ouvrir le fichier.',
    'sched.doc.decisionFailed': 'La décision n\'a pas pu être enregistrée.',
    'sched.doc.confirmBlocked': 'Ce rendez-vous ne peut pas être confirmé tant que le document requis n\'est pas accepté.',
    'sched.action.confirm': 'Confirmer',
    'sched.action.decline': 'Refuser',
    'sched.action.cancel': 'Annuler la réservation',
    'sched.action.reschedule': 'Reporter',
    'sched.action.noneAvailable': 'Aucune action disponible pour votre rôle ou ce statut.',
    'sched.cancel.title': 'Annuler la réservation',
    'sched.cancel.reason': 'Motif (facultatif)',
    'sched.cancel.override': 'Ignorer la politique de préavis (gestion)',
    'sched.cancel.submit': 'Confirmer l’annulation',
    'sched.decline.title': 'Refuser le rendez-vous',
    'sched.decline.reason': 'Motif (facultatif)',
    'sched.decline.submit': 'Confirmer le refus',
    'sched.confirm.title': 'Confirmer le rendez-vous',
    'sched.confirm.body': 'Approuver ce rendez-vous ? Le client le verra comme confirmé.',
    'sched.resched.title': 'Reporter le rendez-vous',
    'sched.resched.pick': 'Choisissez un nouvel horaire',
    'sched.resched.loading': 'Chargement des horaires disponibles…',
    'sched.resched.none': 'Aucun horaire disponible pour ce type et ce prestataire.',
    'sched.resched.reason': 'Motif (facultatif)',
    'sched.resched.submit': 'Confirmer le report',
    'sched.resched.override': 'Ignorer la politique de préavis (gestion)',
    'sched.toast.confirmed': 'Rendez-vous confirmé',
    'sched.toast.declined': 'Rendez-vous refusé',
    'sched.toast.cancelled': 'Rendez-vous annulé',
    'sched.toast.rescheduled': 'Rendez-vous reporté',
    'sched.toast.failed': 'Échec de l’action',
  },

  pt: {
    'nav.scheduling': 'Agenda',
    'navdesc.manageScheduling': 'Consultas e reservas',
    'page.scheduling.title': 'Agenda',
    'page.scheduling.subtitle': 'Gerir consultas e reservas de {business}',
    'sched.loading': 'A carregar consultas…',
    'sched.failedLoad': 'Falha ao carregar consultas',
    'sched.empty': 'Nenhuma consulta corresponde aos filtros atuais.',
    'sched.emptyHint': 'Consultas marcadas via chat ou voz com IA aparecem aqui.',
    'sched.results': '{count} exibidas',
    'sched.showingRange': 'Mostrando {from}–{to} de {total}',
    'sched.page.prev': 'Anterior',
    'sched.page.next': 'Próximo',
    'sched.waitlist.title': 'Lista de espera',
    'sched.waitlist.empty': 'Ninguém está aguardando.',
    'sched.waitlist.remove': 'Remover',
    'sched.waitlist.window': 'Preferido',
    'sched.waitlist.customer': 'Cliente',
    'sched.waitlist.updated': 'Lista de espera atualizada',
    'sched.waitlist.updateFailed': 'Não foi possível atualizar a lista de espera',
    'sched.filters': 'Filtros',
    'sched.filter.status': 'Estado',
    'sched.filter.allStatuses': 'Todos os estados',
    'sched.filter.provider': 'ID do prestador',
    'sched.filter.customer': 'ID do cliente',
    'sched.filter.from': 'De',
    'sched.filter.to': 'Até',
    'sched.filter.clear': 'Limpar',
    'sched.col.when': 'Quando',
    'sched.col.type': 'Tipo',
    'sched.col.provider': 'Prestador',
    'sched.col.customer': 'Cliente',
    'sched.col.status': 'Estado',
    'sched.status.pending': 'Pendente',
    'sched.status.confirmed': 'Confirmada',
    'sched.status.declined': 'Recusada',
    'sched.status.cancelled': 'Cancelada',
    'sched.status.completed': 'Concluída',
    'sched.status.failed': 'Falhou',
    'sched.status.requested': 'Solicitada',
    'sched.status.reschedule_requested': 'Remarcação solicitada',
    'sched.status.rescheduled': 'Remarcada',
    'sched.status.no_show': 'Não compareceu',
    'sched.status.expired': 'Expirada',
    'sched.detail.title': 'Consulta',
    'sched.detail.select': 'Selecione uma consulta para ver os detalhes.',
    'sched.detail.customer': 'Cliente',
    'sched.detail.provider': 'Prestador',
    'sched.detail.type': 'Tipo de consulta',
    'sched.detail.start': 'Início',
    'sched.detail.end': 'Fim',
    'sched.detail.mode': 'Modo de agenda',
    'sched.detail.resource': 'Recurso',
    'sched.detail.created': 'Criada',
    'sched.detail.updated': 'Atualizada',
    'sched.detail.confirmationSource': 'Origem da confirmação',
    'sched.detail.requirements': 'Requisitos',
    'sched.req.approval': 'Requer aprovação',
    'sched.req.payment': 'Requer pagamento',
    'sched.req.document': 'Requer documento',
    'sched.policy.title': 'Políticas',
    'sched.policy.cancellation': 'Cancelamento',
    'sched.policy.reschedule': 'Remarcação',
    'sched.policy.confirmation': 'Confirmação',
    'sched.policy.allowCustomerCancel': 'Autocancelamento do cliente',
    'sched.policy.allowCustomerReschedule': 'Auto-remarcação do cliente',
    'sched.policy.minNotice': 'Aviso mín. (min)',
    'sched.policy.maxReschedules': 'Máx. remarcações',
    'sched.policy.meetsNotice': 'Cumpre o aviso',
    'sched.policy.mode': 'Modo',
    'sched.policy.expiresAfter': 'Expira após (min)',
    'sched.policy.knowledgeRefs': 'Referências de política',
    'sched.policy.knowledgeRefsHint': 'Apenas IDs de referência — sem conteúdo.',
    'sched.policy.unlimited': 'Ilimitado',
    'sched.thread.title': 'Atividade',
    'sched.thread.none': 'Sem conversa vinculada.',
    'sched.thread.empty': 'Ainda sem atividade.',
    'sched.thread.loading': 'A carregar atividade…',
    'sched.engine.title': 'Metadados do motor',
    'sched.engine.none': 'Nenhum',
    'sched.doc.title': 'Documento',
    'sched.draftsTitle': 'Documentação clínica',
    'sched.doc.view': 'Ver',
    'sched.doc.accept': 'Aceitar',
    'sched.doc.reject': 'Rejeitar',
    'sched.doc.reasonOptional': 'Motivo (opcional)',
    'sched.doc.confirmReject': 'Confirmar rejeição',
    'sched.doc.cancelReject': 'Cancelar',
    'sched.doc.loading': 'Carregando documento…',
    'sched.doc.retry': 'Tentar novamente',
    'sched.doc.viewFailed': 'Não foi possível abrir o arquivo.',
    'sched.doc.decisionFailed': 'Não foi possível salvar a decisão.',
    'sched.doc.confirmBlocked': 'Este agendamento não pode ser confirmado até que o documento exigido seja aceito.',
    'sched.action.confirm': 'Confirmar',
    'sched.action.decline': 'Recusar',
    'sched.action.cancel': 'Cancelar reserva',
    'sched.action.reschedule': 'Remarcar',
    'sched.action.noneAvailable': 'Nenhuma ação disponível para o seu perfil ou este estado.',
    'sched.cancel.title': 'Cancelar reserva',
    'sched.cancel.reason': 'Motivo (opcional)',
    'sched.cancel.override': 'Ignorar política de aviso (gestão)',
    'sched.cancel.submit': 'Confirmar cancelamento',
    'sched.decline.title': 'Recusar consulta',
    'sched.decline.reason': 'Motivo (opcional)',
    'sched.decline.submit': 'Confirmar recusa',
    'sched.confirm.title': 'Confirmar consulta',
    'sched.confirm.body': 'Aprovar esta consulta? O cliente verá como confirmada.',
    'sched.resched.title': 'Remarcar consulta',
    'sched.resched.pick': 'Escolha um novo horário',
    'sched.resched.loading': 'A carregar horários disponíveis…',
    'sched.resched.none': 'Sem horários disponíveis para este tipo e prestador.',
    'sched.resched.reason': 'Motivo (opcional)',
    'sched.resched.submit': 'Confirmar remarcação',
    'sched.resched.override': 'Ignorar política de aviso (gestão)',
    'sched.toast.confirmed': 'Consulta confirmada',
    'sched.toast.declined': 'Consulta recusada',
    'sched.toast.cancelled': 'Consulta cancelada',
    'sched.toast.rescheduled': 'Consulta remarcada',
    'sched.toast.failed': 'A ação falhou',
  },

  de: {
    'nav.scheduling': 'Terminplanung',
    'navdesc.manageScheduling': 'Termine & Buchungen',
    'page.scheduling.title': 'Terminplanung',
    'page.scheduling.subtitle': 'Termine und Buchungen für {business} verwalten',
    'sched.loading': 'Termine werden geladen…',
    'sched.failedLoad': 'Termine konnten nicht geladen werden',
    'sched.empty': 'Keine Termine entsprechen den aktuellen Filtern.',
    'sched.emptyHint': 'Über KI-Chat oder -Sprache gebuchte Termine erscheinen hier.',
    'sched.results': '{count} angezeigt',
    'sched.showingRange': '{from}–{to} von {total} werden angezeigt',
    'sched.page.prev': 'Zurück',
    'sched.page.next': 'Weiter',
    'sched.waitlist.title': 'Warteliste',
    'sched.waitlist.empty': 'Niemand wartet.',
    'sched.waitlist.remove': 'Entfernen',
    'sched.waitlist.window': 'Bevorzugt',
    'sched.waitlist.customer': 'Kunde',
    'sched.waitlist.updated': 'Warteliste aktualisiert',
    'sched.waitlist.updateFailed': 'Warteliste konnte nicht aktualisiert werden',
    'sched.filters': 'Filter',
    'sched.filter.status': 'Status',
    'sched.filter.allStatuses': 'Alle Status',
    'sched.filter.provider': 'Anbieter-ID',
    'sched.filter.customer': 'Kunden-ID',
    'sched.filter.from': 'Von',
    'sched.filter.to': 'Bis',
    'sched.filter.clear': 'Zurücksetzen',
    'sched.col.when': 'Wann',
    'sched.col.type': 'Typ',
    'sched.col.provider': 'Anbieter',
    'sched.col.customer': 'Kunde',
    'sched.col.status': 'Status',
    'sched.status.pending': 'Ausstehend',
    'sched.status.confirmed': 'Bestätigt',
    'sched.status.declined': 'Abgelehnt',
    'sched.status.cancelled': 'Storniert',
    'sched.status.completed': 'Abgeschlossen',
    'sched.status.failed': 'Fehlgeschlagen',
    'sched.status.requested': 'Angefragt',
    'sched.status.reschedule_requested': 'Verschiebung angefragt',
    'sched.status.rescheduled': 'Verschoben',
    'sched.status.no_show': 'Nicht erschienen',
    'sched.status.expired': 'Abgelaufen',
    'sched.detail.title': 'Termin',
    'sched.detail.select': 'Wählen Sie einen Termin, um Details anzuzeigen.',
    'sched.detail.customer': 'Kunde',
    'sched.detail.provider': 'Anbieter',
    'sched.detail.type': 'Terminart',
    'sched.detail.start': 'Beginn',
    'sched.detail.end': 'Ende',
    'sched.detail.mode': 'Planungsmodus',
    'sched.detail.resource': 'Ressource',
    'sched.detail.created': 'Erstellt',
    'sched.detail.updated': 'Aktualisiert',
    'sched.detail.confirmationSource': 'Bestätigungsquelle',
    'sched.detail.requirements': 'Anforderungen',
    'sched.req.approval': 'Genehmigung erforderlich',
    'sched.req.payment': 'Zahlung erforderlich',
    'sched.req.document': 'Dokument erforderlich',
    'sched.policy.title': 'Richtlinien',
    'sched.policy.cancellation': 'Stornierung',
    'sched.policy.reschedule': 'Verschiebung',
    'sched.policy.confirmation': 'Bestätigung',
    'sched.policy.allowCustomerCancel': 'Kunden-Selbststornierung',
    'sched.policy.allowCustomerReschedule': 'Kunden-Selbstverschiebung',
    'sched.policy.minNotice': 'Mind. Vorlauf (Min)',
    'sched.policy.maxReschedules': 'Max. Verschiebungen',
    'sched.policy.meetsNotice': 'Erfüllt Vorlauffrist',
    'sched.policy.mode': 'Modus',
    'sched.policy.expiresAfter': 'Läuft ab nach (Min)',
    'sched.policy.knowledgeRefs': 'Richtlinien-Referenzen',
    'sched.policy.knowledgeRefsHint': 'Nur Referenz-IDs — kein Inhalt angezeigt.',
    'sched.policy.unlimited': 'Unbegrenzt',
    'sched.thread.title': 'Aktivität',
    'sched.thread.none': 'Keine verknüpfte Konversation.',
    'sched.thread.empty': 'Noch keine Aktivität.',
    'sched.thread.loading': 'Aktivität wird geladen…',
    'sched.engine.title': 'Engine-Metadaten',
    'sched.engine.none': 'Keine',
    'sched.doc.title': 'Dokument',
    'sched.draftsTitle': 'Klinische Dokumentation',
    'sched.doc.view': 'Ansehen',
    'sched.doc.accept': 'Annehmen',
    'sched.doc.reject': 'Ablehnen',
    'sched.doc.reasonOptional': 'Grund (optional)',
    'sched.doc.confirmReject': 'Ablehnung bestätigen',
    'sched.doc.cancelReject': 'Abbrechen',
    'sched.doc.loading': 'Dokument wird geladen…',
    'sched.doc.retry': 'Erneut versuchen',
    'sched.doc.viewFailed': 'Die Datei konnte nicht geöffnet werden.',
    'sched.doc.decisionFailed': 'Die Entscheidung konnte nicht gespeichert werden.',
    'sched.doc.confirmBlocked': 'Dieser Termin kann erst bestätigt werden, wenn das erforderliche Dokument angenommen wurde.',
    'sched.action.confirm': 'Bestätigen',
    'sched.action.decline': 'Ablehnen',
    'sched.action.cancel': 'Buchung stornieren',
    'sched.action.reschedule': 'Verschieben',
    'sched.action.noneAvailable': 'Keine Aktionen für Ihre Rolle oder diesen Status verfügbar.',
    'sched.cancel.title': 'Buchung stornieren',
    'sched.cancel.reason': 'Grund (optional)',
    'sched.cancel.override': 'Vorlaufrichtlinie übergehen (Management)',
    'sched.cancel.submit': 'Stornierung bestätigen',
    'sched.decline.title': 'Termin ablehnen',
    'sched.decline.reason': 'Grund (optional)',
    'sched.decline.submit': 'Ablehnung bestätigen',
    'sched.confirm.title': 'Termin bestätigen',
    'sched.confirm.body': 'Diesen Termin genehmigen? Der Kunde sieht ihn als bestätigt.',
    'sched.resched.title': 'Termin verschieben',
    'sched.resched.pick': 'Neue Zeit wählen',
    'sched.resched.loading': 'Verfügbare Zeiten werden geladen…',
    'sched.resched.none': 'Keine verfügbaren Zeiten für diese Art und diesen Anbieter.',
    'sched.resched.reason': 'Grund (optional)',
    'sched.resched.submit': 'Verschiebung bestätigen',
    'sched.resched.override': 'Vorlaufrichtlinie übergehen (Management)',
    'sched.toast.confirmed': 'Termin bestätigt',
    'sched.toast.declined': 'Termin abgelehnt',
    'sched.toast.cancelled': 'Termin storniert',
    'sched.toast.rescheduled': 'Termin verschoben',
    'sched.toast.failed': 'Aktion fehlgeschlagen',
  },

  it: {
    'nav.scheduling': 'Agenda',
    'navdesc.manageScheduling': 'Appuntamenti e prenotazioni',
    'page.scheduling.title': 'Agenda',
    'page.scheduling.subtitle': 'Gestisci appuntamenti e prenotazioni di {business}',
    'sched.loading': 'Caricamento appuntamenti…',
    'sched.failedLoad': 'Impossibile caricare gli appuntamenti',
    'sched.empty': 'Nessun appuntamento corrisponde ai filtri attuali.',
    'sched.emptyHint': 'Gli appuntamenti prenotati via chat o voce IA compaiono qui.',
    'sched.results': '{count} mostrati',
    'sched.showingRange': 'Visualizzazione {from}–{to} di {total}',
    'sched.page.prev': 'Precedente',
    'sched.page.next': 'Successivo',
    'sched.waitlist.title': 'Lista d’attesa',
    'sched.waitlist.empty': 'Nessuno in attesa.',
    'sched.waitlist.remove': 'Rimuovi',
    'sched.waitlist.window': 'Preferito',
    'sched.waitlist.customer': 'Cliente',
    'sched.waitlist.updated': 'Lista d’attesa aggiornata',
    'sched.waitlist.updateFailed': 'Impossibile aggiornare la lista d’attesa',
    'sched.filters': 'Filtri',
    'sched.filter.status': 'Stato',
    'sched.filter.allStatuses': 'Tutti gli stati',
    'sched.filter.provider': 'ID fornitore',
    'sched.filter.customer': 'ID cliente',
    'sched.filter.from': 'Da',
    'sched.filter.to': 'A',
    'sched.filter.clear': 'Cancella',
    'sched.col.when': 'Quando',
    'sched.col.type': 'Tipo',
    'sched.col.provider': 'Fornitore',
    'sched.col.customer': 'Cliente',
    'sched.col.status': 'Stato',
    'sched.status.pending': 'In attesa',
    'sched.status.confirmed': 'Confermato',
    'sched.status.declined': 'Rifiutato',
    'sched.status.cancelled': 'Annullato',
    'sched.status.completed': 'Completato',
    'sched.status.failed': 'Fallito',
    'sched.status.requested': 'Richiesto',
    'sched.status.reschedule_requested': 'Spostamento richiesto',
    'sched.status.rescheduled': 'Riprogrammato',
    'sched.status.no_show': 'Assente',
    'sched.status.expired': 'Scaduto',
    'sched.detail.title': 'Appuntamento',
    'sched.detail.select': 'Seleziona un appuntamento per vedere i dettagli.',
    'sched.detail.customer': 'Cliente',
    'sched.detail.provider': 'Fornitore',
    'sched.detail.type': 'Tipo di appuntamento',
    'sched.detail.start': 'Inizio',
    'sched.detail.end': 'Fine',
    'sched.detail.mode': 'Modalità agenda',
    'sched.detail.resource': 'Risorsa',
    'sched.detail.created': 'Creato',
    'sched.detail.updated': 'Aggiornato',
    'sched.detail.confirmationSource': 'Origine conferma',
    'sched.detail.requirements': 'Requisiti',
    'sched.req.approval': 'Richiede approvazione',
    'sched.req.payment': 'Richiede pagamento',
    'sched.req.document': 'Richiede documento',
    'sched.policy.title': 'Politiche',
    'sched.policy.cancellation': 'Annullamento',
    'sched.policy.reschedule': 'Riprogrammazione',
    'sched.policy.confirmation': 'Conferma',
    'sched.policy.allowCustomerCancel': 'Autoannullamento cliente',
    'sched.policy.allowCustomerReschedule': 'Autoriprogrammazione cliente',
    'sched.policy.minNotice': 'Preavviso min. (min)',
    'sched.policy.maxReschedules': 'Max riprogrammazioni',
    'sched.policy.meetsNotice': 'Rispetta il preavviso',
    'sched.policy.mode': 'Modalità',
    'sched.policy.expiresAfter': 'Scade dopo (min)',
    'sched.policy.knowledgeRefs': 'Riferimenti di policy',
    'sched.policy.knowledgeRefsHint': 'Solo ID di riferimento — nessun contenuto.',
    'sched.policy.unlimited': 'Illimitato',
    'sched.thread.title': 'Attività',
    'sched.thread.none': 'Nessuna conversazione collegata.',
    'sched.thread.empty': 'Ancora nessuna attività.',
    'sched.thread.loading': 'Caricamento attività…',
    'sched.engine.title': 'Metadati del motore',
    'sched.engine.none': 'Nessuno',
    'sched.doc.title': 'Documento',
    'sched.draftsTitle': 'Documentazione clinica',
    'sched.doc.view': 'Visualizza',
    'sched.doc.accept': 'Accetta',
    'sched.doc.reject': 'Rifiuta',
    'sched.doc.reasonOptional': 'Motivo (facoltativo)',
    'sched.doc.confirmReject': 'Conferma rifiuto',
    'sched.doc.cancelReject': 'Annulla',
    'sched.doc.loading': 'Caricamento del documento…',
    'sched.doc.retry': 'Riprova',
    'sched.doc.viewFailed': 'Impossibile aprire il file.',
    'sched.doc.decisionFailed': 'Impossibile salvare la decisione.',
    'sched.doc.confirmBlocked': 'Questo appuntamento non può essere confermato finché il documento richiesto non viene accettato.',
    'sched.action.confirm': 'Conferma',
    'sched.action.decline': 'Rifiuta',
    'sched.action.cancel': 'Annulla prenotazione',
    'sched.action.reschedule': 'Riprogramma',
    'sched.action.noneAvailable': 'Nessuna azione disponibile per il tuo ruolo o questo stato.',
    'sched.cancel.title': 'Annulla prenotazione',
    'sched.cancel.reason': 'Motivo (facoltativo)',
    'sched.cancel.override': 'Ignora la policy di preavviso (gestione)',
    'sched.cancel.submit': 'Conferma annullamento',
    'sched.decline.title': 'Rifiuta appuntamento',
    'sched.decline.reason': 'Motivo (facoltativo)',
    'sched.decline.submit': 'Conferma rifiuto',
    'sched.confirm.title': 'Conferma appuntamento',
    'sched.confirm.body': 'Approvare questo appuntamento? Il cliente lo vedrà come confermato.',
    'sched.resched.title': 'Riprogramma appuntamento',
    'sched.resched.pick': 'Scegli un nuovo orario',
    'sched.resched.loading': 'Caricamento orari disponibili…',
    'sched.resched.none': 'Nessun orario disponibile per questo tipo e fornitore.',
    'sched.resched.reason': 'Motivo (facoltativo)',
    'sched.resched.submit': 'Conferma riprogrammazione',
    'sched.resched.override': 'Ignora la policy di preavviso (gestione)',
    'sched.toast.confirmed': 'Appuntamento confermato',
    'sched.toast.declined': 'Appuntamento rifiutato',
    'sched.toast.cancelled': 'Appuntamento annullato',
    'sched.toast.rescheduled': 'Appuntamento riprogrammato',
    'sched.toast.failed': 'Azione non riuscita',
  },

  ja: {
    'nav.scheduling': 'スケジュール',
    'navdesc.manageScheduling': '予約の管理',
    'page.scheduling.title': 'スケジュール',
    'page.scheduling.subtitle': '{business} の予約を管理',
    'sched.loading': '予約を読み込み中…',
    'sched.failedLoad': '予約の読み込みに失敗しました',
    'sched.empty': '現在のフィルターに一致する予約はありません。',
    'sched.emptyHint': 'AIチャットや音声で取られた予約がここに表示されます。',
    'sched.results': '{count} 件表示',
    'sched.showingRange': '{total} 件中 {from}–{to} 件を表示',
    'sched.page.prev': '前へ',
    'sched.page.next': '次へ',
    'sched.waitlist.title': 'キャンセル待ち',
    'sched.waitlist.empty': '待機中の方はいません。',
    'sched.waitlist.remove': '削除',
    'sched.waitlist.window': '希望',
    'sched.waitlist.customer': 'お客様',
    'sched.waitlist.updated': 'キャンセル待ちを更新しました',
    'sched.waitlist.updateFailed': 'キャンセル待ちを更新できませんでした',
    'sched.filters': 'フィルター',
    'sched.filter.status': 'ステータス',
    'sched.filter.allStatuses': 'すべてのステータス',
    'sched.filter.provider': '担当者ID',
    'sched.filter.customer': '顧客ID',
    'sched.filter.from': '開始',
    'sched.filter.to': '終了',
    'sched.filter.clear': 'クリア',
    'sched.col.when': '日時',
    'sched.col.type': '種類',
    'sched.col.provider': '担当者',
    'sched.col.customer': '顧客',
    'sched.col.status': 'ステータス',
    'sched.status.pending': '保留中',
    'sched.status.confirmed': '確定',
    'sched.status.declined': '却下',
    'sched.status.cancelled': 'キャンセル',
    'sched.status.completed': '完了',
    'sched.status.failed': '失敗',
    'sched.status.requested': 'リクエスト済み',
    'sched.status.reschedule_requested': '変更リクエスト',
    'sched.status.rescheduled': '変更済み',
    'sched.status.no_show': '無断欠席',
    'sched.status.expired': '期限切れ',
    'sched.detail.title': '予約',
    'sched.detail.select': '詳細を表示する予約を選択してください。',
    'sched.detail.customer': '顧客',
    'sched.detail.provider': '担当者',
    'sched.detail.type': '予約の種類',
    'sched.detail.start': '開始',
    'sched.detail.end': '終了',
    'sched.detail.mode': 'スケジュールモード',
    'sched.detail.resource': 'リソース',
    'sched.detail.created': '作成日時',
    'sched.detail.updated': '更新日時',
    'sched.detail.confirmationSource': '確定の出所',
    'sched.detail.requirements': '要件',
    'sched.req.approval': '承認が必要',
    'sched.req.payment': '支払いが必要',
    'sched.req.document': '書類が必要',
    'sched.policy.title': 'ポリシー',
    'sched.policy.cancellation': 'キャンセル',
    'sched.policy.reschedule': '変更',
    'sched.policy.confirmation': '確定',
    'sched.policy.allowCustomerCancel': '顧客による自己キャンセル',
    'sched.policy.allowCustomerReschedule': '顧客による自己変更',
    'sched.policy.minNotice': '最小通知（分）',
    'sched.policy.maxReschedules': '最大変更回数',
    'sched.policy.meetsNotice': '通知期限を満たす',
    'sched.policy.mode': 'モード',
    'sched.policy.expiresAfter': '有効期限（分）',
    'sched.policy.knowledgeRefs': 'ポリシー参照',
    'sched.policy.knowledgeRefsHint': '参照IDのみ — 内容は表示されません。',
    'sched.policy.unlimited': '無制限',
    'sched.thread.title': 'アクティビティ',
    'sched.thread.none': 'リンクされた会話はありません。',
    'sched.thread.empty': 'まだアクティビティはありません。',
    'sched.thread.loading': 'アクティビティを読み込み中…',
    'sched.engine.title': 'エンジンのメタデータ',
    'sched.engine.none': 'なし',
    'sched.doc.title': '書類',
    'sched.draftsTitle': '臨床記録',
    'sched.doc.view': '表示',
    'sched.doc.accept': '承認',
    'sched.doc.reject': '却下',
    'sched.doc.reasonOptional': '理由（任意）',
    'sched.doc.confirmReject': '却下を確定',
    'sched.doc.cancelReject': 'キャンセル',
    'sched.doc.loading': '書類を読み込んでいます…',
    'sched.doc.retry': '再試行',
    'sched.doc.viewFailed': 'ファイルを開けませんでした。',
    'sched.doc.decisionFailed': '判断を保存できませんでした。',
    'sched.doc.confirmBlocked': '必要な書類が承認されるまで、この予約は確定できません。',
    'sched.action.confirm': '確定',
    'sched.action.decline': '却下',
    'sched.action.cancel': '予約をキャンセル',
    'sched.action.reschedule': '変更',
    'sched.action.noneAvailable': 'あなたの権限またはこのステータスで利用できる操作はありません。',
    'sched.cancel.title': '予約をキャンセル',
    'sched.cancel.reason': '理由（任意）',
    'sched.cancel.override': '通知ポリシーを上書き（管理者）',
    'sched.cancel.submit': 'キャンセルを確定',
    'sched.decline.title': '予約を却下',
    'sched.decline.reason': '理由（任意）',
    'sched.decline.submit': '却下を確定',
    'sched.confirm.title': '予約を確定',
    'sched.confirm.body': 'この予約を承認しますか？顧客には確定として表示されます。',
    'sched.resched.title': '予約を変更',
    'sched.resched.pick': '新しい時間を選択',
    'sched.resched.loading': '空き時間を読み込み中…',
    'sched.resched.none': 'この種類と担当者で利用可能な時間はありません。',
    'sched.resched.reason': '理由（任意）',
    'sched.resched.submit': '変更を確定',
    'sched.resched.override': '通知ポリシーを上書き（管理者）',
    'sched.toast.confirmed': '予約を確定しました',
    'sched.toast.declined': '予約を却下しました',
    'sched.toast.cancelled': '予約をキャンセルしました',
    'sched.toast.rescheduled': '予約を変更しました',
    'sched.toast.failed': '操作に失敗しました',
  },

  ko: {
    'nav.scheduling': '일정',
    'navdesc.manageScheduling': '예약 관리',
    'page.scheduling.title': '일정',
    'page.scheduling.subtitle': '{business}의 예약을 관리하세요',
    'sched.loading': '예약을 불러오는 중…',
    'sched.failedLoad': '예약을 불러오지 못했습니다',
    'sched.empty': '현재 필터와 일치하는 예약이 없습니다.',
    'sched.emptyHint': 'AI 채팅 또는 음성으로 예약된 항목이 여기에 표시됩니다.',
    'sched.results': '{count}건 표시',
    'sched.showingRange': '전체 {total}개 중 {from}–{to}개 표시',
    'sched.page.prev': '이전',
    'sched.page.next': '다음',
    'sched.waitlist.title': '대기자 명단',
    'sched.waitlist.empty': '대기 중인 고객이 없습니다.',
    'sched.waitlist.remove': '제거',
    'sched.waitlist.window': '희망',
    'sched.waitlist.customer': '고객',
    'sched.waitlist.updated': '대기자 명단 업데이트됨',
    'sched.waitlist.updateFailed': '대기자 명단을 업데이트하지 못했습니다',
    'sched.filters': '필터',
    'sched.filter.status': '상태',
    'sched.filter.allStatuses': '모든 상태',
    'sched.filter.provider': '담당자 ID',
    'sched.filter.customer': '고객 ID',
    'sched.filter.from': '시작',
    'sched.filter.to': '종료',
    'sched.filter.clear': '지우기',
    'sched.col.when': '일시',
    'sched.col.type': '유형',
    'sched.col.provider': '담당자',
    'sched.col.customer': '고객',
    'sched.col.status': '상태',
    'sched.status.pending': '대기 중',
    'sched.status.confirmed': '확정',
    'sched.status.declined': '거절',
    'sched.status.cancelled': '취소',
    'sched.status.completed': '완료',
    'sched.status.failed': '실패',
    'sched.status.requested': '요청됨',
    'sched.status.reschedule_requested': '변경 요청',
    'sched.status.rescheduled': '변경됨',
    'sched.status.no_show': '노쇼',
    'sched.status.expired': '만료',
    'sched.detail.title': '예약',
    'sched.detail.select': '세부 정보를 보려면 예약을 선택하세요.',
    'sched.detail.customer': '고객',
    'sched.detail.provider': '담당자',
    'sched.detail.type': '예약 유형',
    'sched.detail.start': '시작',
    'sched.detail.end': '종료',
    'sched.detail.mode': '일정 모드',
    'sched.detail.resource': '리소스',
    'sched.detail.created': '생성됨',
    'sched.detail.updated': '업데이트됨',
    'sched.detail.confirmationSource': '확정 출처',
    'sched.detail.requirements': '요구 사항',
    'sched.req.approval': '승인 필요',
    'sched.req.payment': '결제 필요',
    'sched.req.document': '서류 필요',
    'sched.policy.title': '정책',
    'sched.policy.cancellation': '취소',
    'sched.policy.reschedule': '변경',
    'sched.policy.confirmation': '확정',
    'sched.policy.allowCustomerCancel': '고객 자가 취소',
    'sched.policy.allowCustomerReschedule': '고객 자가 변경',
    'sched.policy.minNotice': '최소 통지(분)',
    'sched.policy.maxReschedules': '최대 변경 횟수',
    'sched.policy.meetsNotice': '통지 기한 충족',
    'sched.policy.mode': '모드',
    'sched.policy.expiresAfter': '만료 시간(분)',
    'sched.policy.knowledgeRefs': '정책 참조',
    'sched.policy.knowledgeRefsHint': '참조 ID만 — 내용은 표시되지 않습니다.',
    'sched.policy.unlimited': '무제한',
    'sched.thread.title': '활동',
    'sched.thread.none': '연결된 대화가 없습니다.',
    'sched.thread.empty': '아직 활동이 없습니다.',
    'sched.thread.loading': '활동을 불러오는 중…',
    'sched.engine.title': '엔진 메타데이터',
    'sched.engine.none': '없음',
    'sched.doc.title': '문서',
    'sched.draftsTitle': '임상 문서',
    'sched.doc.view': '보기',
    'sched.doc.accept': '승인',
    'sched.doc.reject': '거부',
    'sched.doc.reasonOptional': '사유(선택)',
    'sched.doc.confirmReject': '거부 확인',
    'sched.doc.cancelReject': '취소',
    'sched.doc.loading': '문서를 불러오는 중…',
    'sched.doc.retry': '다시 시도',
    'sched.doc.viewFailed': '파일을 열 수 없습니다.',
    'sched.doc.decisionFailed': '결정을 저장하지 못했습니다.',
    'sched.doc.confirmBlocked': '필요한 문서가 승인될 때까지 이 예약을 확정할 수 없습니다.',
    'sched.action.confirm': '확정',
    'sched.action.decline': '거절',
    'sched.action.cancel': '예약 취소',
    'sched.action.reschedule': '변경',
    'sched.action.noneAvailable': '귀하의 역할 또는 이 상태에서 사용할 수 있는 작업이 없습니다.',
    'sched.cancel.title': '예약 취소',
    'sched.cancel.reason': '사유(선택)',
    'sched.cancel.override': '통지 정책 무시(관리자)',
    'sched.cancel.submit': '취소 확정',
    'sched.decline.title': '예약 거절',
    'sched.decline.reason': '사유(선택)',
    'sched.decline.submit': '거절 확정',
    'sched.confirm.title': '예약 확정',
    'sched.confirm.body': '이 예약을 승인하시겠습니까? 고객에게는 확정으로 표시됩니다.',
    'sched.resched.title': '예약 변경',
    'sched.resched.pick': '새 시간 선택',
    'sched.resched.loading': '이용 가능한 시간을 불러오는 중…',
    'sched.resched.none': '이 유형과 담당자에 대해 이용 가능한 시간이 없습니다.',
    'sched.resched.reason': '사유(선택)',
    'sched.resched.submit': '변경 확정',
    'sched.resched.override': '통지 정책 무시(관리자)',
    'sched.toast.confirmed': '예약이 확정되었습니다',
    'sched.toast.declined': '예약이 거절되었습니다',
    'sched.toast.cancelled': '예약이 취소되었습니다',
    'sched.toast.rescheduled': '예약이 변경되었습니다',
    'sched.toast.failed': '작업이 실패했습니다',
  },

  zh: {
    'nav.scheduling': '日程',
    'navdesc.manageScheduling': '预约与预订',
    'page.scheduling.title': '日程',
    'page.scheduling.subtitle': '管理 {business} 的预约与预订',
    'sched.loading': '正在加载预约…',
    'sched.failedLoad': '加载预约失败',
    'sched.empty': '没有符合当前筛选条件的预约。',
    'sched.emptyHint': '通过 AI 聊天或语音预订的预约会显示在此处。',
    'sched.results': '显示 {count} 条',
    'sched.showingRange': '显示第 {from}–{to} 条，共 {total} 条',
    'sched.page.prev': '上一页',
    'sched.page.next': '下一页',
    'sched.waitlist.title': '候补名单',
    'sched.waitlist.empty': '暂无等候者。',
    'sched.waitlist.remove': '移除',
    'sched.waitlist.window': '期望',
    'sched.waitlist.customer': '客户',
    'sched.waitlist.updated': '候补名单已更新',
    'sched.waitlist.updateFailed': '无法更新候补名单',
    'sched.filters': '筛选',
    'sched.filter.status': '状态',
    'sched.filter.allStatuses': '全部状态',
    'sched.filter.provider': '服务人员 ID',
    'sched.filter.customer': '客户 ID',
    'sched.filter.from': '起',
    'sched.filter.to': '至',
    'sched.filter.clear': '清除',
    'sched.col.when': '时间',
    'sched.col.type': '类型',
    'sched.col.provider': '服务人员',
    'sched.col.customer': '客户',
    'sched.col.status': '状态',
    'sched.status.pending': '待处理',
    'sched.status.confirmed': '已确认',
    'sched.status.declined': '已拒绝',
    'sched.status.cancelled': '已取消',
    'sched.status.completed': '已完成',
    'sched.status.failed': '失败',
    'sched.status.requested': '已请求',
    'sched.status.reschedule_requested': '已请求改期',
    'sched.status.rescheduled': '已改期',
    'sched.status.no_show': '未到',
    'sched.status.expired': '已过期',
    'sched.detail.title': '预约',
    'sched.detail.select': '选择一个预约以查看详情。',
    'sched.detail.customer': '客户',
    'sched.detail.provider': '服务人员',
    'sched.detail.type': '预约类型',
    'sched.detail.start': '开始',
    'sched.detail.end': '结束',
    'sched.detail.mode': '排期模式',
    'sched.detail.resource': '资源',
    'sched.detail.created': '创建时间',
    'sched.detail.updated': '更新时间',
    'sched.detail.confirmationSource': '确认来源',
    'sched.detail.requirements': '要求',
    'sched.req.approval': '需要审批',
    'sched.req.payment': '需要付款',
    'sched.req.document': '需要文件',
    'sched.policy.title': '政策',
    'sched.policy.cancellation': '取消',
    'sched.policy.reschedule': '改期',
    'sched.policy.confirmation': '确认',
    'sched.policy.allowCustomerCancel': '客户自助取消',
    'sched.policy.allowCustomerReschedule': '客户自助改期',
    'sched.policy.minNotice': '最短提前（分钟）',
    'sched.policy.maxReschedules': '最多改期次数',
    'sched.policy.meetsNotice': '满足提前期限',
    'sched.policy.mode': '模式',
    'sched.policy.expiresAfter': '到期时间（分钟）',
    'sched.policy.knowledgeRefs': '政策参考',
    'sched.policy.knowledgeRefsHint': '仅参考 ID — 不显示内容。',
    'sched.policy.unlimited': '不限',
    'sched.thread.title': '动态',
    'sched.thread.none': '没有关联的会话。',
    'sched.thread.empty': '暂无动态。',
    'sched.thread.loading': '正在加载动态…',
    'sched.engine.title': '引擎元数据',
    'sched.engine.none': '无',
    'sched.doc.title': '文件',
    'sched.draftsTitle': '临床文档',
    'sched.doc.view': '查看',
    'sched.doc.accept': '接受',
    'sched.doc.reject': '拒绝',
    'sched.doc.reasonOptional': '原因（可选）',
    'sched.doc.confirmReject': '确认拒绝',
    'sched.doc.cancelReject': '取消',
    'sched.doc.loading': '正在加载文件…',
    'sched.doc.retry': '重试',
    'sched.doc.viewFailed': '无法打开该文件。',
    'sched.doc.decisionFailed': '无法保存该决定。',
    'sched.doc.confirmBlocked': '在所需文件被接受之前，无法确认此预约。',
    'sched.action.confirm': '确认',
    'sched.action.decline': '拒绝',
    'sched.action.cancel': '取消预订',
    'sched.action.reschedule': '改期',
    'sched.action.noneAvailable': '您的角色或此状态没有可用操作。',
    'sched.cancel.title': '取消预订',
    'sched.cancel.reason': '原因（可选）',
    'sched.cancel.override': '覆盖提前通知政策（管理层）',
    'sched.cancel.submit': '确认取消',
    'sched.decline.title': '拒绝预约',
    'sched.decline.reason': '原因（可选）',
    'sched.decline.submit': '确认拒绝',
    'sched.confirm.title': '确认预约',
    'sched.confirm.body': '批准此预约吗？客户将看到其为已确认。',
    'sched.resched.title': '改期预约',
    'sched.resched.pick': '选择新的时间',
    'sched.resched.loading': '正在加载可用时间…',
    'sched.resched.none': '此类型和服务人员没有可用时间。',
    'sched.resched.reason': '原因（可选）',
    'sched.resched.submit': '确认改期',
    'sched.resched.override': '覆盖提前通知政策（管理层）',
    'sched.toast.confirmed': '预约已确认',
    'sched.toast.declined': '预约已拒绝',
    'sched.toast.cancelled': '预约已取消',
    'sched.toast.rescheduled': '预约已改期',
    'sched.toast.failed': '操作失败',
  },

  ar: {
    'nav.scheduling': 'الجدولة',
    'navdesc.manageScheduling': 'المواعيد والحجوزات',
    'page.scheduling.title': 'الجدولة',
    'page.scheduling.subtitle': 'إدارة المواعيد والحجوزات لـ {business}',
    'sched.loading': 'جارٍ تحميل المواعيد…',
    'sched.failedLoad': 'فشل تحميل المواعيد',
    'sched.empty': 'لا توجد مواعيد تطابق عوامل التصفية الحالية.',
    'sched.emptyHint': 'تظهر هنا المواعيد المحجوزة عبر دردشة أو صوت الذكاء الاصطناعي.',
    'sched.results': '{count} معروضة',
    'sched.showingRange': 'عرض {from}–{to} من أصل {total}',
    'sched.page.prev': 'السابق',
    'sched.page.next': 'التالي',
    'sched.waitlist.title': 'قائمة الانتظار',
    'sched.waitlist.empty': 'لا أحد في الانتظار.',
    'sched.waitlist.remove': 'إزالة',
    'sched.waitlist.window': 'المفضل',
    'sched.waitlist.customer': 'العميل',
    'sched.waitlist.updated': 'تم تحديث قائمة الانتظار',
    'sched.waitlist.updateFailed': 'تعذر تحديث قائمة الانتظار',
    'sched.filters': 'عوامل التصفية',
    'sched.filter.status': 'الحالة',
    'sched.filter.allStatuses': 'كل الحالات',
    'sched.filter.provider': 'معرّف مقدم الخدمة',
    'sched.filter.customer': 'معرّف العميل',
    'sched.filter.from': 'من',
    'sched.filter.to': 'إلى',
    'sched.filter.clear': 'مسح',
    'sched.col.when': 'الوقت',
    'sched.col.type': 'النوع',
    'sched.col.provider': 'مقدم الخدمة',
    'sched.col.customer': 'العميل',
    'sched.col.status': 'الحالة',
    'sched.status.pending': 'قيد الانتظار',
    'sched.status.confirmed': 'مؤكد',
    'sched.status.declined': 'مرفوض',
    'sched.status.cancelled': 'ملغى',
    'sched.status.completed': 'مكتمل',
    'sched.status.failed': 'فشل',
    'sched.status.requested': 'مطلوب',
    'sched.status.reschedule_requested': 'طُلبت إعادة الجدولة',
    'sched.status.rescheduled': 'أُعيدت جدولته',
    'sched.status.no_show': 'لم يحضر',
    'sched.status.expired': 'منتهٍ',
    'sched.detail.title': 'الموعد',
    'sched.detail.select': 'اختر موعدًا لعرض التفاصيل.',
    'sched.detail.customer': 'العميل',
    'sched.detail.provider': 'مقدم الخدمة',
    'sched.detail.type': 'نوع الموعد',
    'sched.detail.start': 'البداية',
    'sched.detail.end': 'النهاية',
    'sched.detail.mode': 'وضع الجدولة',
    'sched.detail.resource': 'المورد',
    'sched.detail.created': 'أُنشئ',
    'sched.detail.updated': 'حُدّث',
    'sched.detail.confirmationSource': 'مصدر التأكيد',
    'sched.detail.requirements': 'المتطلبات',
    'sched.req.approval': 'يتطلب موافقة',
    'sched.req.payment': 'يتطلب دفعًا',
    'sched.req.document': 'يتطلب مستندًا',
    'sched.policy.title': 'السياسات',
    'sched.policy.cancellation': 'الإلغاء',
    'sched.policy.reschedule': 'إعادة الجدولة',
    'sched.policy.confirmation': 'التأكيد',
    'sched.policy.allowCustomerCancel': 'إلغاء ذاتي من العميل',
    'sched.policy.allowCustomerReschedule': 'إعادة جدولة ذاتية من العميل',
    'sched.policy.minNotice': 'أدنى إشعار (دقيقة)',
    'sched.policy.maxReschedules': 'أقصى عدد لإعادة الجدولة',
    'sched.policy.meetsNotice': 'يفي بمهلة الإشعار',
    'sched.policy.mode': 'الوضع',
    'sched.policy.expiresAfter': 'ينتهي بعد (دقيقة)',
    'sched.policy.knowledgeRefs': 'مراجع السياسة',
    'sched.policy.knowledgeRefsHint': 'معرّفات مرجعية فقط — لا يُعرض المحتوى.',
    'sched.policy.unlimited': 'غير محدود',
    'sched.thread.title': 'النشاط',
    'sched.thread.none': 'لا توجد محادثة مرتبطة.',
    'sched.thread.empty': 'لا يوجد نشاط بعد.',
    'sched.thread.loading': 'جارٍ تحميل النشاط…',
    'sched.engine.title': 'بيانات المحرك',
    'sched.engine.none': 'لا شيء',
    'sched.doc.title': 'مستند',
    'sched.draftsTitle': 'التوثيق السريري',
    'sched.doc.view': 'عرض',
    'sched.doc.accept': 'قبول',
    'sched.doc.reject': 'رفض',
    'sched.doc.reasonOptional': 'السبب (اختياري)',
    'sched.doc.confirmReject': 'تأكيد الرفض',
    'sched.doc.cancelReject': 'إلغاء',
    'sched.doc.loading': 'جارٍ تحميل المستند…',
    'sched.doc.retry': 'إعادة المحاولة',
    'sched.doc.viewFailed': 'تعذّر فتح الملف.',
    'sched.doc.decisionFailed': 'تعذّر حفظ القرار.',
    'sched.doc.confirmBlocked': 'لا يمكن تأكيد هذا الموعد حتى يتم قبول المستند المطلوب.',
    'sched.action.confirm': 'تأكيد',
    'sched.action.decline': 'رفض',
    'sched.action.cancel': 'إلغاء الحجز',
    'sched.action.reschedule': 'إعادة الجدولة',
    'sched.action.noneAvailable': 'لا توجد إجراءات متاحة لدورك أو لهذه الحالة.',
    'sched.cancel.title': 'إلغاء الحجز',
    'sched.cancel.reason': 'السبب (اختياري)',
    'sched.cancel.override': 'تجاوز سياسة الإشعار (الإدارة)',
    'sched.cancel.submit': 'تأكيد الإلغاء',
    'sched.decline.title': 'رفض الموعد',
    'sched.decline.reason': 'السبب (اختياري)',
    'sched.decline.submit': 'تأكيد الرفض',
    'sched.confirm.title': 'تأكيد الموعد',
    'sched.confirm.body': 'الموافقة على هذا الموعد؟ سيراه العميل كمؤكد.',
    'sched.resched.title': 'إعادة جدولة الموعد',
    'sched.resched.pick': 'اختر وقتًا جديدًا',
    'sched.resched.loading': 'جارٍ تحميل الأوقات المتاحة…',
    'sched.resched.none': 'لا توجد أوقات متاحة لهذا النوع ومقدم الخدمة.',
    'sched.resched.reason': 'السبب (اختياري)',
    'sched.resched.submit': 'تأكيد إعادة الجدولة',
    'sched.resched.override': 'تجاوز سياسة الإشعار (الإدارة)',
    'sched.toast.confirmed': 'تم تأكيد الموعد',
    'sched.toast.declined': 'تم رفض الموعد',
    'sched.toast.cancelled': 'تم إلغاء الموعد',
    'sched.toast.rescheduled': 'تمت إعادة جدولة الموعد',
    'sched.toast.failed': 'فشل الإجراء',
  },
};

export default schedulingTranslations;
